import React from "react";

export default function Stars({ value = 5, reviews = null, size = 0.9 }) {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  const stars = [];
  for (let i = 0; i < 5; i++) {
    if (i < full) stars.push("★");
    else if (i === full && half) stars.push("★");
    else stars.push("☆");
  }
  return (
    <div className="flex items-center gap-2" data-testid="stars-rating">
      <span className="mt-stars" style={{ fontSize: `${size}rem` }}>{stars.join("")}</span>
      {reviews !== null && (
        <span className="font-mono text-[0.65rem] tracking-mt uppercase" style={{ color: "var(--mt-text-muted)" }}>
          ({reviews} reviews)
        </span>
      )}
    </div>
  );
}
